export default "<p>\r\n  base-page works!\r\n</p>\r\n"